import React, { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { api, saveAuth, getUser, errMsg } from "../lib/api";
import { Trash, Plus, EnvelopeSimple, User as UserIcon, ShieldCheck } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function Settings() {
  const [user, setUser] = useState(getUser());
  const [childName, setChildName] = useState(user?.child_name || "");
  const [grade, setGrade] = useState(user?.grade || "7. sınıf");
  const [emails, setEmails] = useState(user?.parent_emails || []);
  const [newEmail, setNewEmail] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      setChildName(r.data.child_name);
      setGrade(r.data.grade);
      setEmails(r.data.parent_emails || []);
    }).catch(() => {});
  }, []);

  const addEmail = () => {
    if (!newEmail.includes("@")) { toast.error("Geçerli bir e-posta gir"); return; }
    if (emails.includes(newEmail)) { toast.warning("Zaten ekli"); return; }
    setEmails([...emails, newEmail]);
    setNewEmail("");
  };
  const removeEmail = (e) => setEmails(emails.filter((x) => x !== e));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/auth/profile", {
        child_name: childName,
        grade,
        parent_emails: emails,
      });
      const token = localStorage.getItem("evodevi_token");
      saveAuth(token, data);
      setUser(data);
      toast.success("Kaydedildi");
    } catch (e) {
      toast.error(errMsg(e, "Kaydedilemedi"));
    } finally { setSaving(false); }
  };

  return (
    <Shell title="Ayarlar">
      <h1 className="font-outfit font-extrabold text-3xl text-brand-ink mb-5">Ayarlar</h1>

      <section className="bg-white rounded-3xl p-5 shadow-sm mb-4">
        <div className="flex items-center gap-2 mb-3">
          <UserIcon size={20} weight="duotone" color="#FFA200" />
          <div className="font-outfit font-bold text-brand-ink">Profil</div>
        </div>
        <label className="block font-nunito text-sm text-brand-ink2 mb-1.5">Adın</label>
        <input
          data-testid="settings-child-name"
          value={childName}
          onChange={(e) => setChildName(e.target.value)}
          className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink mb-3"
        />
        <label className="block font-nunito text-sm text-brand-ink2 mb-1.5">Sınıf</label>
        <select
          data-testid="settings-grade"
          value={grade}
          onChange={(e) => setGrade(e.target.value)}
          className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink"
        >
          {["5. sınıf","6. sınıf","7. sınıf","8. sınıf","9. sınıf","10. sınıf"].map((g) => <option key={g} value={g}>{g}</option>)}
        </select>
      </section>

      <section className="bg-white rounded-3xl p-5 shadow-sm mb-4">
        <div className="flex items-center gap-2 mb-3">
          <EnvelopeSimple size={20} weight="duotone" color="#FFA200" />
          <div className="font-outfit font-bold text-brand-ink">Veli e-postaları</div>
        </div>
        <div className="flex flex-col gap-2 mb-3" data-testid="parent-emails-list">
          {emails.length === 0 && <div className="text-sm font-nunito text-brand-ink2">Henüz e-posta eklenmedi. Rapor gönderilemez.</div>}
          {emails.map((e) => (
            <div key={e} className="flex items-center gap-2 bg-brand-paperAlt rounded-2xl px-4 py-2.5" data-testid={`parent-email-${e}`}>
              <EnvelopeSimple size={16} />
              <div className="flex-1 font-nunito text-sm text-brand-ink truncate">{e}</div>
              <button onClick={() => removeEmail(e)} data-testid={`remove-email-${e}`} className="p-1.5 rounded-full hover:bg-white">
                <Trash size={16} weight="duotone" color="#E76F51" />
              </button>
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <input
            data-testid="new-parent-email"
            type="email"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            placeholder="anne@mail.com"
            className="flex-1 bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink"
          />
          <button onClick={addEmail} data-testid="add-parent-email-btn" className="w-12 h-12 bg-brand-primary rounded-2xl flex items-center justify-center">
            <Plus size={22} weight="bold" color="#1D3557" />
          </button>
        </div>
      </section>

      <button
        data-testid="settings-save-btn"
        onClick={save}
        disabled={saving}
        className="w-full bg-brand-primary text-brand-ink font-outfit font-bold text-lg py-4 rounded-full shadow-[0_4px_18px_rgba(255,183,3,0.45)] disabled:opacity-50"
      >{saving ? "Kaydediliyor..." : "Kaydet"}</button>

      {user?.is_admin && (
        <Link
          to="/admin"
          data-testid="admin-panel-link"
          className="mt-4 w-full bg-brand-ink text-white font-outfit font-bold py-4 rounded-full flex items-center justify-center gap-2"
        >
          <ShieldCheck size={20} weight="duotone" color="#FFB703" /> Admin Paneli
        </Link>
      )}
    </Shell>
  );
}
